<template>
  <div>
    <el-dialog
        :title="$t('productList.Listing')"
        :visible.sync="dialogVisible"
        width="800px"
        :before-close="handleClose"
        :close-on-click-modal="false"
        v-if="isPC">
        <div>
          <el-form label-position="top" label-width="80px" :model="formObj" ref="formObj" class="dialog-box">
            <div class="f">
              <div class="f1" style="flex: 1;margin-right: 20px">
                <el-form-item :label="$t('productList.Platform')" required prop="platformCode" :rules="[{ required: true, message: 'platform is required'}]" style="margin-bottom: 10px">
                    <el-select v-model="formObj.platformCode" style="width: 100%" @change="platformChange">
                        <el-option v-for="item in platformOptions" :key="item.platformCode" :label="item.platformName" :value="item.platformCode"></el-option>
                    </el-select>
                </el-form-item>
              </div>
              <div class="f1" style="flex: 1">
                <el-form-item required prop="storeId" :rules="[{ required: true, trigger: 'blur', message: 'store is required'}]" style="margin-bottom: 10px">
                  <template slot="label">
                    {{$t('productList.Store')}}
                    <el-tooltip class="item" effect="dark" :content="$t('productList.storeTips')" placement="top-start">
                        <i class="el-icon-warning-outline pointer"></i>
                    </el-tooltip>
                  </template>
                    <el-select v-model="formObj.storeId" style="width: 100%" @change="storeChange" filterable>
                        <el-option v-for="item in storeSelectList" :key="item.storeId" :label="item.storeName" :value="item.storeId"></el-option>
                    </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="f" v-if="formObj.platformCode !== 'TT'">
              <div class="f1" style="flex: 1;margin-right: 20px">
                <el-form-item :label="$t('Publish.ProductList.Components.BatchListToStoreModal.Categorys')" v-if="formObj.platformCode === 'WC'" style="margin-bottom: 10px">
                  <el-cascader
                    :options="collectionSelectList"
                    :props="{ expandTrigger: 'hover', multiple: true, value: 'categoryId', label: 'name', checkStrictly: true }"
                    clearable
                    v-model="categoryIds"
                    :show-all-levels="false"
                    style="width: 370px"
                    class="borderTo2"></el-cascader>
                </el-form-item>
                <el-form-item :label="$t('Publish.ProductList.Components.BatchListToStoreModal.Collection')" style="margin-bottom: 10px" v-else>
                  <el-select v-if="formObj.platformCode === 'SP'" v-model="formObj.collectionId" multiple style="width: 100%">
                    <el-option v-for="item in collectionSelectList" :key="item.collectionId" :label="item.title" :value="item.collectionId"></el-option>
                  </el-select>
                  <el-select v-else v-model="formObj.collectionId" style="width: 100%">
                    <el-option v-for="item in collectionSelectList" :key="item.collectionId" :label="item.title" :value="item.collectionId"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="f1" style="flex: 1">
                <el-form-item style="margin-bottom: 10px">
                  <template slot="label">
                    <div style="opacity: 0">aaa</div>
                  </template>
                  <el-button type="text" icon="el-icon-refresh" class="update-button" :disabled="syncCollectionDisabled" @click="publishGetSyncCollections">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Update') }}</el-button>
                </el-form-item>
              </div>
            </div>

            <!-- TT WarehouseList -->
            <div class="f" v-if="formObj.platformCode === 'TT'">
              <div style="flex: 1;margin-right: 20px">
              <el-form-item :label="$t('publishEdit.WarehouseName')" required prop="warehouseId" :rules="[{ required: true, trigger: 'blur', message: 'Warehouse Name is required'}]" style="margin-bottom: 10px">
                <el-select v-model="formObj.collectionId" style="width: 100%">
                  <el-option v-for="item in ttWarehouseList" :key="item.warehouseId" :label="item.warehouseName" :value="item.warehouseId"></el-option>
                </el-select>
              </el-form-item>
              </div>
              <div style="flex: 1;"></div>
            </div>

            <!-- Tags -->
            <div class="f" v-if="formObj.platformCode !== 'TT'">
              <div class="f1" style="flex: 1;margin-right: 20px">
                <el-form-item :label="$t('Publish.ProductList.Components.BatchListToStoreModal.Tags')" style="margin-bottom: 10px">
                  <el-select v-if="formObj.platformCode === 'WC'" v-model="formObj.tags" multiple filterable allow-create default-first-option style="width: 100%">
                      <el-option v-for="tag in tagsOption" :key="tag.tagId" :label="tag.name" :value="tag.name" />
                  </el-select>

                  <div class="tags-box" v-else>
                    <el-tag v-for="tag in formObj.tags" :key="tag" closable :disable-transitions="false" @close="() => handleCloseTag(tag)">{{ tag }}</el-tag>
                    <el-input v-if="tagInputVisible" v-model="tagInputValue"   ref="saveTagInput" size="small" class="input-new-tag" :style="{'margin-left': formObj.tags.length ? '10px' : '0px'}" @keyup.enter.native="handleTagInputConfirm" @blur="handleTagInputConfirm" />
                    <el-button v-else class="button-new-tag" :style="{'margin-left': formObj.tags.length ? '10px' : '0px'}" size="small" @click="showTagInput">
                      <i class="el-icon-plus" />
                    </el-button>
                  </div>
                </el-form-item>
              </div>

              <div v-if="formObj.platformCode === 'WC'" class="f1" style="flex: 1">
                <el-form-item style="margin-bottom: 10px">
                  <template slot="label">
                    <div style="opacity: 0">aaa</div>
                  </template>
                  <el-button  type="text" icon="el-icon-refresh" class="update-button" :disabled="syncCollectionDisabled" @click="syncWoocommerceTag">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Update') }}</el-button>
                </el-form-item>
              </div>
            </div>

            <div>
              <div>
              <el-form-item :label="$t('Publish.ProductList.Components.BatchListToStoreModal.SizeUnit')" style="margin-bottom: 10px">
                <!-- <el-radio-group v-model="formObj.sizeUnit">
                  <el-radio :label="'cm'">cm</el-radio>
                  <el-radio :label="'inch'">inch</el-radio>
                </el-radio-group> -->
                <el-checkbox-group v-model="sizeUnit" @change="sizeUnitChange">
                  <el-checkbox value="inch" label="inch" />
                  <el-checkbox value="cm" label="cm" />
                </el-checkbox-group>
              </el-form-item>
              </div>

              <el-form-item required style="margin-bottom: 10px">
                  <template slot="label">
                    <span>{{ $t('Publish.ProductList.Components.BatchListToStoreModal.SuggestedPrice') }}({{ formObj.currency || 'USD' }})</span>
                      <el-tooltip class="item" effect="dark" :content="`${$t('productList.priceTips')}`" placement="top-start">
                          <i class="el-icon-warning-outline pointer" style="margin-left: 5px;"></i>
                      </el-tooltip>
                  </template>
                  <div>
                    KakaClo {{ $t('productList.Price') }}
                    <el-select v-model="formObj.priceRatioType" style="width:60px">
                      <el-option label="x" value="x"></el-option>
                      <el-option label="+" value="+"></el-option>
                    </el-select>
                    <el-input v-model="formObj.priceRatio" style="width: 200px;margin: 0 10px" placeholder="0" v-toFloat class="noRound">
                      <!-- <template slot="append">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Multiplier') }}</template> -->
                      <template slot="append">{{ formObj.priceRatioType === 'x' ? 'Profit Margin' : 'Profit' }}</template>
                    </el-input>
                    <span>+ {{ $t('Publish.ProductList.Components.BatchListToStoreModal.ShippingCost') }}</span>
                    <span>= {{ $t('Publish.ProductList.Components.BatchListToStoreModal.SugestPrice') }}</span>
                  </div>
                  <div style="color: red" v-if="formObj.priceRatioType === 'x' && formObj.priceRatio > 20">{{ $t('productList.priceRatioGT20Tip') }}</div>
              </el-form-item>

              <el-form-item style="margin-bottom: 10px" v-if="formObj.platformCode !== 'TT'">
                  <template slot="label">
                    <span>{{ $t('Publish.ProductList.Components.BatchListToStoreModal.CompareAtPrice') }}({{ formObj.currency || 'USD' }})</span>
                  </template>
                  <div :class="{'actual-price': setPriceTips}">
                    KakaClo {{ $t('productList.Price') }}
                    <el-select v-model="formObj.compareAtPriceRatioType" style="width:60px">
                      <el-option label="x" value="x"></el-option>
                      <el-option label="+" value="+"></el-option>
                    </el-select>
                    <el-input v-model="formObj.compareAtPriceRatio" style="width: 200px;margin: 0 10px" placeholder="0" v-toFloat class="noRound">
                      <!-- <template slot="append">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Multiplier') }}</template> -->
                      <template slot="append">{{ formObj.compareAtPriceRatioType === 'x' ? 'Profit Margin' : 'Profit' }}</template>
                    </el-input>
                    <span>+ {{ $t('Publish.ProductList.Components.BatchListToStoreModal.ShippingCost') }}</span>
                    <span>= {{ $t('Publish.ProductList.Components.BatchListToStoreModal.CompareAtPrice') }}</span>
                  </div>
                  <div style="color: #EB5757;" v-if="setPriceTips">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Tips1') }}</div>
              </el-form-item>
            </div>
            <div v-if="formObj.platformCode && formObj.platformCode !== 'WC'">
              <div>{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Tips2') }}</div>
              <el-form-item required style="margin-bottom: 10px">
                <el-radio v-model="formObj.filterDuplicateSpu" :label="true">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Skip') }}</el-radio>
                <el-radio v-model="formObj.filterDuplicateSpu" :label="false">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Duplicate') }}</el-radio>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('productList.Cancel') }}</el-button>
          <el-button type="primary" @click="submit">{{ $t('productList.ListNow') }}</el-button>
        </span>
    </el-dialog>
    <div v-else class="MT_main">
      <div class="back bg-white">
        <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
        {{ $t('Publish.ProductList.Components.BatchListToStoreModal.Listing') }}
      </div>
      <div class="logistics bg-white">
        <BigSelect :value="formObj.platformCode" :columns="platformOptions" :placeholder="$t('Publish.ProductList.Components.BatchListToStoreModal.Platform')" :isRequired="true" @change="MTplatformChange" :customField="{label: 'platformName', value: 'platformCode'}"></BigSelect>
        <BigSelect :value="formObj.storeId" :columns="storeSelectList" :placeholder="$t('Publish.ProductList.Components.BatchListToStoreModal.Store')" :isRequired="true" @change="MTstoreChange" :customField="{label: 'storeName', value: 'storeId'}"></BigSelect>
        <div v-if="formObj.platformCode === 'WC'" class="mt_category">
          <el-select v-model="categoryIds" style="width: 100%" multiple collapse-tags>
              <el-option v-for="item in collectionSelectList" :key="item.categoryId" :label="item.name" :value="item.categoryId"></el-option>
          </el-select>
        </div>
        <BigSelect :value="formObj.collectionId" :columns="collectionSelectList" :placeholder="$t('Publish.ProductList.Components.BatchListToStoreModal.Collection')" :isRequired="false" @change="MTcollectionChange" :customField="{label: 'title', value: 'collectionId'}" v-else></BigSelect>
        <div class="f--c">
          <el-button type="text" size="mini" icon="el-icon-refresh" :disabled="syncCollectionDisabled" @click="publishGetSyncCollections">{{ $t('publishEdit.SyncCollection') }}</el-button>
        </div>
      </div>
      <div class="price bg-white">
        <div class="title requiredLabel">
          {{ $t('productList.YourPrice') }}
        </div>
        <div>KakaClo {{ $t('productList.Price') }}
          <el-select v-model="formObj.priceRatioType" style="width:60px">
            <el-option label="x" value="x"></el-option>
            <el-option label="+" value="+"></el-option>
          </el-select>
          <el-input v-model="formObj.priceRatio" style="width: 120px;margin: 0 10px" placeholder="0" v-toFloat />= {{ $t('productList.YourPrice') }}</div>
        <div style="color: red" v-if="formObj.priceRatioType === 'x' && formObj.priceRatio > 20">{{ $t('productList.priceRatioGT20Tip') }}</div>
      </div>
      <div v-if="formObj.platformCode && formObj.platformCode !== 'WC'" class="price bg-white">
        <div class="title">
          <!-- {{$t('productList.repeatList')}} <el-checkbox v-model="formObj.filterDuplicateSpu" style="margin-left: 10px"></el-checkbox> -->
          <el-radio v-model="formObj.filterDuplicateSpu" :label="true">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Skip') }}</el-radio>
          <el-radio v-model="formObj.filterDuplicateSpu" :label="false">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Duplicate') }}</el-radio>
        </div>
      </div>
      <div class="bg-white" style="padding: .2rem .3rem">
        {{ $t('Publish.ProductList.Components.BatchListToStoreModal.SizeUnit') }}:
        <!-- <el-radio-group v-model="formObj.sizeUnit">
          <el-radio :label="'cm'">cm</el-radio>
          <el-radio :label="'inch'">inch</el-radio>
        </el-radio-group> -->
        <el-checkbox-group v-model="sizeUnit" @change="sizeUnitChange">
          <el-checkbox value="inch" label="inch" />
          <el-checkbox value="cm" label="cm" />
        </el-checkbox-group>
      </div>
      <div class="bottomBtn f-a">
          <el-button type="primary" @click="submit">{{ $t('productList.ListNow') }}</el-button>
      </div>
    </div>

    <el-dialog :visible.sync="dialogStoreUpdate.dialog" :title="dialogStoreUpdate.title" width="80%" class="dialogStoreUpdate">
      <div style="padding-bottom: 20px">{{ dialogStoreUpdate.message }}</div>
      <div style="text-align: right;">
        <el-button @click="dialogStoreUpdate.dialog = false">Cancel</el-button>
        <el-button type="primary" @click="storeUpdate">Update</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import bus from '@/util/bus'
import BigSelect from '@/components/mobile/BigSelect.vue'
export default {
  components: {
    BigSelect
  },
  data() {
    return {
      dialogStoreUpdate: {
        dialog: false,
        title: 'Tips',
        message: 'Update the Shopify app to list new products!',
        url: undefined
      },
      tagInputVisible: false,
      tagInputValue: undefined,

      dialogVisible: false,
      formObj: {
        platformCode: undefined,
        storeId: undefined,
        storeName: undefined,
        priceRatio: undefined,
        spu: undefined,
        collectionId: undefined,
        filterDuplicateSpu: true,
        sizeUnit: 'inch',
        priceRatioType: 'x',
        compareAtPriceRatioType: 'x',

        tags: [], // 标签(多个以英文逗号隔开)
        compareAtPriceRatio: undefined // 对比价格系数(需大于价格系数)
      },
      sizeUnit: ['inch'],
      logistics: {
        shippingCountryCode: undefined,
        shippingCountryName: undefined,
        warehouseCode: undefined,
        warehouseName: undefined,
        warehouseId: undefined,
        warehouseType: undefined,
        receivingCountryCode: undefined,
        receivingCountryName: undefined,
        channelCode: undefined,
        channelName: undefined
      },
      storeSelectList: [],
      shippingFromList: [],
      receivingList: [],
      channelList: [],
      rules: [],
      collectionSelectList: [],
      syncCollectionDisabled: false,

      tagsOption: [],

      // MT 移动端
      storeId: undefined, // 移动端店铺单选
      categoryIds: [],

      platformOptions: [], // 改版 使用用户自己的店铺

      ttWarehouseList: [] // TT平台仓库
    }
  },
  directives: {
    toFloat: {
      inserted: function(el) {
        const input = el.querySelector('.el-input__inner')
        input.oninput = function(e) {
          let value = input.value.replace(/[^\d.]/g, '')
          input.value = value
        }
        input.onblur = () => {
          let value = parseFloat(input.value)
          if (Number.isNaN(value) || value <= 1) {
            value = null
          } else {
            value = parseFloat(value.toFixed(2))
          }
          input.value = value
        }
      }
    }
  },
  computed: {
    setPriceTips() {
      if (!this.formObj.priceRatio || !this.formObj.compareAtPriceRatio || (this.formObj.priceRatioType !== this.formObj.compareAtPriceRatioType)) {
        return false
      } else {
        return Number.parseFloat(this.formObj.compareAtPriceRatio) <= Number.parseFloat(this.formObj.priceRatio)
      }
    },
    // platformOptions() {
    //   if (!this.$store.state.common.platformOptions.length) this.$store.dispatch('common/getPlatformOptions')
    //   return this.$store.state.common.platformOptions.filter(e => e.platformCode !== 'KA')
    // },
    logisticsTips() {
      return this.$t('productList.logisticsTips')
    }
  },
  created() {
    this.getUserPlatform()
    if (!this.isPC) {
      this.wishListGetShippingFromList()
      this.wishListLoadCountryList()
      this.formObj.spu = this.$store.state.published.MTBatchPublishedListSpu.join(',')
      this.formObj.spuCountryDTOList = this.$store.state.published.MTBatchSpuCountryDTOList
    }
  },
  methods: {
    /**
     * API 获取Tags列表
     */
    async getWoocommerceGetTag() {
      let { data } = await API.woocommerceGetTag({ storeId: this.formObj.storeId })
      this.tagsOption = data && data.list ? data.list : []
    },

    /**
     * API 同步Tags
     */
    async syncWoocommerceTag() {
      let { code } = await API.woocommerceSyncTag({ storeId: this.formObj.storeId })
      if (code === 10000) {
        this.getWoocommerceGetTag()
      }
    },

    /**
     * API 获取店铺设置信息
     */
    async getShopSetInformation(storeId) {
      let { data } = await API.getShopSetInformation({ storeId })
      if (data) {
        this.formObj.priceRatio = data.priceRatio // 定价比例
        this.formObj.compareAtPriceRatio = data.compareRatio // 比价比例
        this.formObj.currency = data.currency // 平台币种
        this.formObj.priceRatioType = data.priceRatioType // 平台计算规则
        this.formObj.compareRatioType = data.compareRatioType // 平台计算规则
      }
    },

    /**
     * API 获取用户创建的店铺
     */
    getUserPlatform() {
      API.getUserPlatform().then(result => {
        this.platformOptions = result.data
        if (result.data.length === 1) {
          this.$set(this.formObj, 'platformCode', result.data[0].platformCode)
          this.isPC ? this.platformChange(result.data[0].platformCode) : this.MTplatformChange(result.data[0].platformCode)
        }
      })
    },

    /**
     * 移除某个Tag
     *
     * @param {String} tag 当前移除的名称
     */
    handleCloseTag(tag) {
      this.formObj.tags.splice(this.formObj.tags.indexOf(tag), 1)
    },

    /**
     * 新增Tags按钮的回调事件
     */
    showTagInput() {
      this.tagInputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    /**
     * 添加Tag
     * 键盘回车或输入框失去焦点时的事件回调
     */
    handleTagInputConfirm() {
      let tagInputValue = this.tagInputValue
      // if (tagInputValue && !this.formObj.tags.includes(tagInputValue)) {
      //   this.formObj.tags.push(tagInputValue)
      // }

      if (tagInputValue) {
        if (this.formObj.tags.includes(tagInputValue)) {
          this.$message.warning(this.$t('publishEdit.repeat'))
        } else if (tagInputValue.length > 255) {
          this.$message.warning('The number of characters in tags cannot exceed 255!')
          tagInputValue = tagInputValue.slice(0, 255)
          this.formObj.tags.push(tagInputValue)
        } else if (this.formObj.tags.length >= 100) {
          this.$message.warning(this.$t('publishEdit.tagLength'))
        } else {
          this.formObj.tags.push(tagInputValue)
        }
      }

      this.tagInputVisible = false
      this.tagInputValue = undefined
    },

    handleClose() {
      this.$refs.formObj.resetFields()
      Object.keys(this.formObj).forEach(key => {
        if (key === 'tags') {
          this.formObj[key] = []
        } else {
          this.formObj[key] = undefined
        }
      })
      this.formObj.filterDuplicateSpu = true
      this.formObj.priceRatioType = 'x'
      this.formObj.compareAtPriceRatioType = 'x'
      Object.keys(this.logistics).forEach(key => {
        this.logistics[key] = undefined
      })
      this.dialogVisible = false
    },
    show(spus, spuCountryDTOList) {
      this.$set(this.formObj, 'spu', spus.join(','))
      // this.$set(this.formObj, 'sizeUnit', 'inch')
      this.$set(this.formObj, 'spuCountryDTOList', spuCountryDTOList)
      this.wishListGetShippingFromList()
      this.wishListLoadCountryList()
      this.dialogVisible = true
    },
    platformChange(platformCode) {
      this.formObj.tags = []
      this.formObj.storeId = undefined
      this.formObj.storeName = undefined
      this.formObj.priceRatio = undefined
      this.formObj.compareAtPriceRatio = undefined
      return new Promise((resolve, reject) => {
        API.orderGetAllStore({ platformCode, userId: this.$store.state.common.userId, storeStatus: 1, authorizeStatus: 1 }).then(res => {
          this.storeSelectList = res.data
          if (res.data.length === 1) {
            this.$set(this.formObj, 'storeId', res.data[0].storeId)
            this.storeChange(res.data[0].storeId)
          }
          this.collectionSelectList = []
          this.formObj.collectionId = platformCode === 'SP' ? [] : undefined
          resolve()
        }).catch(() => reject())
      })
    },
    async wishListGetShippingFromList() {
      let res = await API.wishListGetShippingFromList({ pageSize: 100, pageNumber: 1 })
      // 去重
      const map = {}
      res.data.list.forEach(item => {
        map[item.countryCode] = item
      })
      this.shippingFromList = Object.values(map)
    },
    shippingFromListChange(value) {
      this.logistics.receivingCountryCode = undefined
      // 带出其他属性
      let target = this.shippingFromList.find(e => e.warehouseCode === value) || {}
      const { countryCode: shippingCountryCode, countryCn: shippingCountryName, warehouseCode, warehouseName, warehouseId, warehouseType } = target
      this.logistics = Object.assign(this.logistics, { shippingCountryCode, shippingCountryName, warehouseCode, warehouseName, warehouseId, warehouseType })
      this.wishListGetListingChannel()
    },
    async wishListLoadCountryList() {
      let res = await API.wishListLoadCountryList()
      this.receivingList = res.data
    },
    async receivingChange(value) {
      const { countryNameEn: receivingCountryName } = this.receivingList.find(e => e.countryCode === value) || { countryNameEn: undefined }
      this.logistics.receivingCountryName = receivingCountryName
      this.wishListGetListingChannel()
    },
    async wishListGetListingChannel() {
      if (!this.logistics.shippingCountryCode || !this.logistics.receivingCountryCode) return
      try {
        let res = await API.wishListGetListingChannel({ deliveryCountryCode: this.logistics.receivingCountryCode, shippingCountryCode: this.logistics.shippingCountryCode })
        this.channelList = res.data
      } catch (error) {
        this.$message.error(error.data.message)
      }
    },
    submitParamsHandle() {
      let params = Object.assign({}, this.formObj, { logistics: this.logistics })
      // params.filterDuplicateSpu = !params.filterDuplicateSpu
      // 店铺为单选，格式还是多选

      params.sizeUnit = this.sizeUnit.length > 1 ? 'inch,cm' : this.sizeUnit.join()

      if (!this.formObj.priceRatio) {
        this.$message.warning('Coefficient cannot be empty!')
        return
      }

      if (this.formObj.priceRatio && this.formObj.compareAtPriceRatio && (this.formObj.priceRatioType === this.formObj.compareAtPriceRatioType)) {
        if (+this.formObj.compareAtPriceRatio <= +this.formObj.priceRatio) {
          return
        }
      }

      if (params.tags && params.tags.length) {
        params.tags = params.tags.join(',')
      } else {
        params.tags = undefined
      }

      // collectionId 为数组是格式化
      if (Array.isArray(params.collectionId)) {
        params.collectionId = params.collectionId.join(',')
      }

      params.storeIds = [params.storeId]
      params.storeNames = [params.storeName]
      if (!params.logistics.receivingCountryCode) params.logistics.receivingCountryName = undefined
      if (!params.logistics.shippingCountryCode) {
        params.logistics.shippingCountryName = undefined
        params.logistics.warehouseCode = undefined
        params.logistics.warehouseName = undefined
        params.logistics.warehouseId = undefined
        params.logistics.warehouseType = undefined
      }
      if (!params.logistics.channelCode) params.logistics.channelName = undefined
      if (params.platformCode === 'WC') {
        let categoryIdsStr = ''
        this.categoryIds.forEach(e => {
          categoryIdsStr += e[e.length - 1]
          categoryIdsStr += ','
        })
        categoryIdsStr = categoryIdsStr.slice(0, -1)
        params.categoryIdsStr = categoryIdsStr
      }
      if (Object.keys(params.logistics).every(key => !params.logistics[key])) {
        params.logistics = undefined
        return params
      }
      // 发货地、收货地、物流渠道只要选择了其中一项必须全部选择
      if (params.logistics.shippingCountryCode || params.logistics.receivingCountryCode || params.logistics.channelCode) {
        if (!params.logistics.shippingCountryCode || !params.logistics.receivingCountryCode || !params.logistics.channelCode) {
          this.$message.error(this.logisticsTips)
          params = false
        }
      }
      return params
    },
    async submit() {
      if (this.isPC) {
        this.$refs.formObj.validate(async(valid) => {
          if (valid) {
            const params = this.submitParamsHandle()
            if (!params) return
            if (params.platformCode === 'SP') {
              let res = await API.getPublications({ storeId: params.storeId })
              if (res.code === 10000 && res.data) {
                this.dialogVisible = false
                this.$emit('storePublications', res.data)
                return
              }
            }
            let res = await API.wishListLoadPublishRecord(params)
            if (res.code !== 10000) return this.$message.error(res.message)
            this.$message.success(res.message)
            this.handleClose()
            bus.$emit('batchPublishedSuccess', { platformCode: params.platformCode, storeIds: params.storeIds })
          }
        })
      } else {
        const params = this.submitParamsHandle()
        if (!params) return
        if (params.platformCode === 'SP') {
          let res = await API.getPublications({ storeId: params.storeId })
          if (res.code === 10000 && res.data) {
            this.dialogStoreUpdate.dialog = true
            this.dialogStoreUpdate.url = res.data
            return
          }
        }
        let res = await API.wishListLoadPublishRecord(params)
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$router.go(-1)
      }
    },
    storeChange(value) {
      if (this.formObj.platformCode === 'WC') {
        this.getWoocommerceGetTag()
      }
      this.getShopSetInformation(value)
      const store = this.storeSelectList.find(e => e.storeId === value) || { storeName: undefined }
      this.formObj.storeName = store.storeName
      this.formObj.collectionId = this.formObj.platformCode === 'SP' ? [] : undefined
      this.formObj.tags = []
      if (value) {
        this.publishGetCollections(value)
      }
      if (this.formObj.platformCode === 'TT') {
        this.tiktokListingWarehouses(value)
      }
    },
    channelChange(value) {
      const { channelName } = this.channelList.find(e => e.channelCode === value) || { channelName: null }
      this.logistics.channelName = channelName
    },
    MTplatformChange(value, item) {
      this.formObj.platformCode = value
      this.platformChange(value)
    },
    MTstoreChange(value, item) {
      this.formObj.storeId = value
      // this.formObj.storeIds = [value]
      this.storeChange(this.formObj.storeId)
    },
    MTshippingFromListChange(value, item) {
      this.logistics.warehouseCode = value
      this.shippingFromListChange(value)
    },
    MTreceivingChange(value, item) {
      this.logistics.receivingCountryCode = value
      this.receivingChange(value)
    },
    MTchannelChange(value, item) {
      this.logistics.channelCode = value
      this.channelChange(value)
    },
    // 同步集合
    async publishGetSyncCollections() {
      const { storeId, platformCode } = this.formObj
      try {
        if (!this.syncCollectionDisabled) {
          if (!platformCode) {
            this.$message.error(this.$t('promptText.msg46'))
            return
          }
          if (!storeId) {
            this.$message.error(this.$t('promptText.msg47'))
            return
          }
          this.syncCollectionDisabled = true
          let res
          if (this.formObj.platformCode === 'DJ') {
            res = await API.shoplazzaSyncCollections({ storeId })
          } else if (this.formObj.platformCode === 'SP') {
            res = await API.publishGetSyncCollections({ storeId })
          } else if (this.formObj.platformCode === 'SL') {
            res = await API.shoplineSyncCollections({ storeId })
          } else if (this.formObj.platformCode === 'WC') {
            res = await API.WoocommerceSyncCollections({ storeId })
          }
          this.publishGetCollections(storeId)
          this.$message.success(res.message)
        }
      } catch (err) {
        let message = err.message || err.data.message
        this.$message.error(message)
      }
      this.syncCollectionDisabled = false
    },
    // 获取集合列表
    async publishGetCollections(storeId) {
      try {
        let res
        if (this.formObj.platformCode === 'DJ') {
          res = await API.shoplazzaGetCollections({ storeId })
        } else if (this.formObj.platformCode === 'SP') {
          res = await API.publishGetCollections({ storeId })
        } else if (this.formObj.platformCode === 'SL') {
          res = await API.shoplineGetCollections({ storeId })
        } else if (this.formObj.platformCode === 'WC') {
          res = await API.WoocommerceGetCategories({ storeId })
        }
        const arr = []; const obj = {}
        if (this.formObj.platformCode === 'WC') {
          res.data.list.forEach(e => {
            if (!obj[e.categoryId]) {
              e.collectionId = e.categoryId
              e.title = e.name
              arr.push(e)
            }
            obj[e.categoryId] = 1
          })
        } else {
          res.data.list.forEach(e => {
            if (!obj[e.collectionId]) arr.push(e)
            obj[e.collectionId] = 1
          })
        }
        this.$set(this, 'collectionSelectList', arr)
        this.collectionSelectList = arr
        const clearEmptyChildren = (arr) => {
          arr.forEach(e => {
            if (e.children.length) {
              clearEmptyChildren(e.children)
            } else {
              e.children = null
            }
          })
        }
        this.formObj.platformCode === 'WC' && clearEmptyChildren(this.collectionSelectList)
      } catch (error) {
        console.log(error)
      }
    },
    MTcollectionChange(value) {
      this.formObj.collectionId = value
    },

    // TT获取仓库列表
    tiktokListingWarehouses(storeId) {
      API.tiktokListingWarehouses({
        storeId: storeId
      }).then(res => {
        if (!res.data || !res.data.length) return
        this.ttWarehouseList = res.data
        this.$set(this.formObj, 'collectionId', res.data.find(item => item.isDefault).warehouseId || undefined)
      })
    },

    storeUpdate() {
      window.open(this.dialogStoreUpdate.url, '_blank')
    },

    sizeUnitChange(value) {
      if (!value.length) {
        this.sizeUnit = ['inch']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialogStoreUpdate {
  /deep/ .el-dialog {
    max-width: 700px;
  }
}
/deep/.el-dialog__title {
  font-weight: 600;
}

/deep/.el-cascader__tags {
  .el-tag {
  background-color:  rgba(228, 230, 233, 0.28);
  .el-icon-close {
    color: #CDD4DD;
     background-color:  rgba(228, 230, 233, 0.28);
  }
}
}

/deep/.el-tag.el-tag--info {
 color: #CDD4DD;
  background-color:  rgba(228, 230, 233, 0.28);
}

/deep/.el-tag.el-tag--info .el-tag__close {
  color: #CDD4DD;
  background-color:  rgba(228, 230, 233, 0.28);
}

/deep/.el-tag--medium {
  height: 32px;
  line-height: 32px;
  background-color: #fff;
  border-color: #CDD4DD;
}

/deep/.el-tag .el-tag__close {
  color: #CDD4DD;
  background-color: #fff;
}

/deep/.el-tag.el-tag--info {
  color: #747A87;
}

.update-button {
  font-weight: 400;
}

.el-form--label-top {
  /deep/.el-form-item__label {
    color: #000;
    padding: 0;
  }
}

.tags-box {
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    border-radius: 4px;
    border: 0.5px solid #cdd4dd;
    background-color: #fff;
    .el-icon-plus {
      color: #000;
      font-weight: 700;
    }
  }

  .input-new-tag {
    width: 90px;
    vertical-align: bottom;
    /deep/.el-input__inner {
      border-radius: 4px;
    }
  }
}

.actual-price {
  /deep/.el-input__inner,
  /deep/.el-input-group__append {
    border-color: #EB5757;
  }
}

.dialog-box {
  /deep/ .el-select .el-input input{
    border-radius: 4px !important;
  }
}
.MT_main{
  .back {
      color: #7B7B7B;
      padding: .2rem;
      font-size: .4rem;
      margin-bottom: .2rem;
  }
  .logistics {
    margin-bottom: .2rem;
    padding: 0 .3rem;
  }
  .price {
    padding: .2rem .3rem;
    margin-bottom: .2rem;
    .requiredLabel::before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
    }
  }
  .ship {
    padding: .2rem .3rem;
    margin-bottom: .2rem;
  }
  .channel {
    padding: .2rem .3rem;
  }
  .bottomBtn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: 0 -.1rem .1rem #dcdfe6;
    background-color: #fff;
    height: 1.2rem;
    align-items: center;
    >.el-button {
      height: .8rem;
      width: 7rem;
    }
  }
}
.noRound {
  /deep/.el-input__inner{
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  /deep/.el-input-group__append{
    background-color: #fff;
  }
}
.mt_category {
  /deep/.el-input__inner{
    border-radius: 0px !important;
    padding: 0px !important;
    border: none;
    height: 42px;
    font-size: .28rem;
  }
  /deep/.el-input__suffix{
    right: -6px;
  }
}
/deep/.el-select-dropdown__item{
  max-width: 900px;
  height: auto;
}
/deep/.borderTo2{
  .el-input__inner{
    border-radius: 2px !important;
  }
}
</style>
